import React from "react";
import {
  Modal,
  Input,
  Form,
  Button,
  message,
  DatePicker,
  Icon,
  Radio,
  Divider,
} from "antd";
import auth from "../../../common/utility/auth";
import DetalleLogisticaTipoImporteGanancia from "./DetalleFormModal/DetalleLogisticaTipoImporteGanancia";
import DetalleLogisticaServicio from "./DetalleFormModal/DetalleLogisticaServicio";
import moment from "moment";
import {
  VALIDAR_STOCK,
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
} from "../../../common/types/parametroType";
import { FORMAT_3DECIMALS } from "../../../common/types/regularExpresionType";
import { DOLARES_AMERICANOS, SOLES } from "../../../common/types/monedaType";
import { PRODUCTO, SERVICIO } from "../../../common/types/tipoProductoType";
const { Search } = Input;
const InputGroup = Input.Group;
class LogisticaTipoImporteGananciaFormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(5)))
      this.props.form.setFieldsValue({
        [`arrImporteGananciaSoles[${property}]`]: "0.00000",
        [`arrImporteGananciaDolares[${property}]`]: "0.00000",
        [`arrPrecioUnitarioSoles[${property}]`]: "0.00000",
        [`arrValorUnitarioSoles[${property}]`]: "0.00000",
        [`arrPrecioUnitarioDolares[${property}]`]: "0.00000",
        [`arrValorUnitarioDolares[${property}]`]: "0.00000",
      });
    else
      this.props.form.setFieldsValue({
        [`arrImporteGananciaSoles[${property}]`]: parseFloat(value).toFixed(5),
        [`arrImporteGananciaDolares[${property}]`]: parseFloat(value).toFixed(5),
        [`arrPrecioUnitarioSoles[${property}]`]: parseFloat(value).toFixed(5),
        [`arrValorUnitarioSoles[${property}]`]: parseFloat(value).toFixed(5),
        [`arrPrecioUnitarioDolares[${property}]`]: parseFloat(value).toFixed(5),
        [`arrValorUnitarioDolares[${property}]`]: parseFloat(value).toFixed(5),
      });
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleSave = (row, e) => {
    if (e !== undefined) e.preventDefault();

    if (e === undefined || e.keyCode === 13)
      this.props.form.validateFields((errors, values) => {
        if (!errors) {
          var params = auth.user().parametros;
          var precioUnitarioInclyIGV =
            params.filter(
              (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
            )[0].valor === "1"
              ? true
              : false;
              
          var valor = 0;
          if(values.idTipoProducto == SERVICIO)
          {
            if (!precioUnitarioInclyIGV && values.idMoneda === SOLES) {
              valor = parseFloat(values.arrValorUnitarioSoles["LP" + row.id]);
            } else if (precioUnitarioInclyIGV && values.idMoneda === SOLES) {
              valor = parseFloat(values.arrPrecioUnitarioSoles["LP" + row.id]);
            } else if (
              !precioUnitarioInclyIGV &&
              values.idMoneda === DOLARES_AMERICANOS
            ) {
              valor = parseFloat(values.arrValorUnitarioDolares["LP" + row.id]);
            } else if (
              precioUnitarioInclyIGV &&
              values.idMoneda === DOLARES_AMERICANOS
            ) {
              valor = parseFloat(values.arrPrecioUnitarioDolares["LP" + row.id]);
            }
          }else{
            if (values.idMoneda === SOLES) {
              valor = parseFloat(values.arrImporteGananciaSoles["LP" + row.id]);
            } else  {
              valor = parseFloat(values.arrImporteGananciaDolares["LP" + row.id]);
            } 

            if (valor === 0){
              message.warning("El importe de ganancia debe ser mayor a 0");
              return;
            }
          }
          const form = {
            id: row.id,
            listaPrecioId: values.id,
            idMoneda: values.idMoneda,
            valor: valor,
            lote: row.lote,
          };
          this.props.onSave(form, this.props.form);
        }
      });
  };

  render() {
    const {
      getFieldDecorator,
      getFieldValue
    } = this.props.form;
    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("idTipoProducto", { initialValue: this.props.formValues.idTipoProducto });
    return (
      <Modal
        title={"Detalle de Lista de Precios - Importe de Ganancia"}
        visible={this.props.visible}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        closable={true}
        style={{ top: 30 }}
        width="1300px"
        footer={[
          <Button key="1" onClick={this.handleCancel}>
            Cancelar
          </Button>,
        ]}
      >
        <Form>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-6 form-group">
              <span style={{ fontWeight: "500" }}>Tipo de Cambio Diario</span>
            </div>
            <div className="col-md-6 form-group">
              <span style={{ fontWeight: "500" }}>Configuración de Precio</span>
            </div>
          </div>
          <Divider style={{ marginTop: "0px" }} />
          <div className="row">
            <div className="col-md-2 form-group">
              <Form.Item label="Fecha">
                {getFieldDecorator("fechaStr", {
                  initialValue: moment(
                    this.props.formValues.fechaStr,
                    "DD/MM/YYYY"
                  ),
                })(
                  <DatePicker
                    className="first-input"
                    placeholder="Seleccione fecha"
                    prefix={
                      <Icon
                        type="filter"
                        style={{ color: "rgba(0,0,0,.25)" }}
                      />
                    }
                    disabled={true}
                    format="DD/MM/YYYY"
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Compra">
                {getFieldDecorator("tipoCambioCompra", {
                  initialValue: parseFloat(
                    this.props.formValues.tipoCambioCompra
                  ).toFixed(3),
                })(
                  <Input
                    disabled={true}
                    className="text-right second-input"
                    placeholder="Ingresar Tipo de Cambio Compra"
                    autoComplete="off"
                    onBlur={(e) =>
                      this.handleCompleteDecimals(
                        "tipoCambioCompra",
                        e.target.value
                      )
                    }
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Venta">
                {getFieldDecorator("tipoCambio", {
                  initialValue: parseFloat(
                    this.props.formValues.tipoCambio
                  ).toFixed(3),
                })(
                  <Input
                    disabled={true}
                    className="text-right second-input"
                    placeholder="Ingresar Tipo de Cambio"
                    autoComplete="off"
                    onBlur={(e) =>
                      this.handleCompleteDecimals("tipoCambio", e.target.value)
                    }
                  />
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator("idMoneda", {
                  initialValue: SOLES,
                })(
                  <Radio.Group
                  onChange={(e) =>
                    this.props.onBuscarProducto("", getFieldValue("idTipoProducto"))
                  }
                  >
                    {this.props.formValues.monedas.map((item) => (
                      <Radio key={item.id} value={item.id}>
                        {item.nombre}
                      </Radio>
                    ))}
                  </Radio.Group>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Tipo">
                {getFieldDecorator("idTipoProducto", {
                  initialValue: PRODUCTO,
                })(
                  <Radio.Group
                    onChange={(e) =>
                      this.props.onBuscarProducto("", e.target.value)
                    }
                  >
                    {this.props.formValues.tiposProductos.map((item) => (
                      <Radio key={item.id} value={item.id}>
                        {item.nombre}
                      </Radio>
                    ))}
                  </Radio.Group>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-md-12 form-group">
              <span style={{ fontWeight: "500" }}>Filtro de Búsqueda</span>
            </div>
          </div>
          <Divider style={{ marginTop: "0px" }} />

          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Código o Nombre">
                {getFieldDecorator("nombre", {
                  initialValue: this.props.formValues.nombre,
                })(
                  <Search
                    placeholder="Búsqueda por Código o Nombre"
                    autoComplete="off"
                    maxLength={100}
                    loading={this.props.formValues.searchLoading}
                    onSearch={(value) =>
                      this.props.onBuscarProducto(value, getFieldValue("idTipoProducto"))
                    }
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              {getFieldValue("idTipoProducto") === PRODUCTO ? (
                <DetalleLogisticaTipoImporteGanancia
                  source={this.props.formValues.detalle}
                  onEdit={this.props.onEdit}
                  onSave={this.handleSave}
                  onGetFieldDecorator={getFieldDecorator}
                  onGetFieldValue={getFieldValue}
                  onCompleteDecimals={this.handleCompleteDecimals}
                  form={this.props.form}
                />
              ) : (
                <DetalleLogisticaServicio
                  source={this.props.formValues.detalle}
                  onEdit={this.props.onEdit}
                  onSave={this.handleSave}
                  onGetFieldDecorator={getFieldDecorator}
                  onGetFieldValue={getFieldValue}
                  onCompleteDecimals={this.handleCompleteDecimals}
                  form={this.props.form}
                />
              )}
            </div>
          </div>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(LogisticaTipoImporteGananciaFormModal);
